const { unset } = require('lodash')
const abTestingPrefix = 'fe.resi.ab.testing'

const getABTests = featureFlags => {
  return Object.keys(featureFlags).reduce((acc, flag) => {
    if (flag.startsWith(abTestingPrefix) && featureFlags[flag]?.test) {
      acc[flag] = featureFlags[flag]
    }
    return acc
  }, {})
}

const getABTestData = featureFlags => {
  return Object.keys(featureFlags).reduce((acc, flag) => {
    if (flag.startsWith(abTestingPrefix) && featureFlags[flag]?.test) {
      const testData = { test: featureFlags[flag].test }
      unset(testData, 'test.version')
      acc[flag] = testData
    }
    return acc
  }, {})
}

module.exports = {
  getABTests,
  getABTestData,
}
